import { Controller } from 'stimulus';
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import toArray from '@/helpers/toArray';

class FormValidationController extends Controller {
  connect() {
    this.preventSubmitDisabling = this.element.dataset.preventSubmitDisabling === 'true';

    porta({
      target: this.element,
      messages: nl,
      onValidate: (formElement) => {
        this.disableSubmitButton(formElement);
        this.updateConnector();
      },
      onError: (formElement) => {
        this.enableSubmitButton(formElement);
        this.updateConnector();
      },
    });

    if (this.hasPageTitleTarget && !this.pageTitleTarget.value) {
      this.pageTitleTarget.value = document.title.substring(0, 200);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  updateConnector() {
    // Vacancy pages have a connector module that draws the line between blocks.
    // On for example errors, the line should redraw.
    const event = new CustomEvent('connector:recalculate', { bubbles: true });
    window.dispatchEvent(event);
  }

  disableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, false);
  }

  enableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, true);
  }

  // eslint-disable-next-line class-methods-use-this
  toggleSubmitButtonState(formElement, state) {
    if (this.preventSubmitDisabling) return;

    toArray(formElement.querySelectorAll('[type="submit"]')).forEach((button) => {
      button[state ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    });
  }
}

FormValidationController.targets = [
  'pageTitle',
];

export default FormValidationController;
